import { render, staticRenderFns } from "./ThemedButton.vue?vue&type=template&id=27d49001&scoped=true"
import script from "./ThemedButton.vue?vue&type=script&lang=ts"
export * from "./ThemedButton.vue?vue&type=script&lang=ts"
import style0 from "./ThemedButton.vue?vue&type=style&index=0&id=27d49001&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d49001",
  null
  
)

export default component.exports